<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useBreakpoints } from '@/lib/utils'
import BaseButton from '@/components/ui/button/BaseButton.vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const { t } = useI18n()
const { isTabletPortrait } = useBreakpoints()
const currentButtonSize = computed(() =>
	isTabletPortrait.value ? 'medium' : 'small',
)
</script>

<template>
	<div class="bs-container">
		<div
			class="col-span-12 flex flex-col items-center gap-casual-friends py-distant-acquaintances"
		>
			<BaseIcon
				name="pcs-404"
				class="aspect-square w-[168px] mdp:w-[224px] mdl:w-[300px]"
			/>

			<div class="text-center">
				<div class="typography-h4-str mb-16px">
					{{ t('pcs_404_not_found') }}
				</div>
				<div class="typography-b3-reg">{{ t('pcs_404_message') }}</div>
			</div>

			<a href="/shop">
				<BaseButton variant="secondary" :size="currentButtonSize">
					{{ t('pcs_404_back_to_home') }}
				</BaseButton>
			</a>
		</div>
	</div>
</template>
